import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types';

export const setIsCreatable: YJSChangeHandler<DatabaseChangeType.SET_IS_CREATABLE> = ({
  ydb,
  change
}) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.creatable = change.isCreatable;
  });
};
